import { createContext } from 'react';

/**
 * Context compartilhado entre MeProvider e BeMeProvider.
 */
export const meContext = createContext({});
